import { options } from './Options'

const policyType = {
  'Whole Life': 1,
  Term: 2,
  ILP: 3,
  Endowment: 4,
  Annuity: 5,
  'Personal Accident': 6,
  'H & S': 7,
  'Universal Life': 8,
  'Variable Universal Life': 9
}

export const PolicyTypeOptions: options[] = Object.keys(policyType).map(key => {
  return {
    label: key,
    value: policyType[key]
  }
})
